/* eslint-disable @typescript-eslint/no-explicit-any */
import {
    ReminderPublisherApiSuggestReminderPublishersReminderPublisherCollectionRequest,
    SuggestReminderPublishersReminderPublisherCollection200Response,
    ReminderPublisherApiPrepareReminderPublisherReminderPublisherCollectionRequest,
    ReminderPublisherApi,
} from '@europrocurement/l2d-domain/openApi/ApiAchats';

import { SupplierSuggestion, SocietyEnumValue } from '../types/reminderPublisherTypes';

/**
 * Service pour gérer les opérations liées aux rappels fournisseurs
 */
export const reminderPublisherService = {
    /**
     * Récupère les suggestions de rappels fournisseurs, filtrées par société
     * @param request Fonction de requête API
     * @param idSociete ID de la société pour filtrer les résultats (optionnel)
     * @returns Liste des suggestions de rappels
     */
    async getSuggestions(
        request: <T>(api: Promise<T>, options?: any) => Promise<any>,
        reminderPublisherApi: ReminderPublisherApi,
        idSociete?: SocietyEnumValue,
    ): Promise<SupplierSuggestion[]> {
        // Paramètres de la requête - filtrer par idSociete seulement si sélectionné
        const requestParameters: ReminderPublisherApiSuggestReminderPublishersReminderPublisherCollectionRequest =
            {};

        if (idSociete !== undefined && idSociete !== null) {
            requestParameters.idSociete = idSociete;
        }

        const result = await request(
            reminderPublisherApi.suggestReminderPublishersReminderPublisherCollection(
                requestParameters,
            ),
            { withToaster: false },
        );

        const { suggestions } =
            result.data as SuggestReminderPublishersReminderPublisherCollection200Response;

        // Filtrer les suggestions pour ne garder que celles avec des factures
        const filteredSuggestions = (suggestions || []).filter(
            (s) => s.factures && s.factures.length > 0,
        );

        return filteredSuggestions;
    },

    /**
     * Crée un rappel fournisseur
     * @param request Fonction de requête API
     * @param suggestion La suggestion sélectionnée
     * @param customMessage Message personnalisé à inclure
     * @param fallbackSocietyId ID de société par défaut
     * @param selectedSocietyId ID de société sélectionnée
     */
    async createReminderPublisher(
        request: <T>(api: Promise<T>, options?: any) => Promise<any>,
        suggestion: SupplierSuggestion,
        customMessage: string,
        fallbackSocietyId: number,
        reminderPublisherApi: ReminderPublisherApi,
        selectedSocietyId?: SocietyEnumValue | null,
    ): Promise<any> {
        const { factures, fournisseur, idSociete } = suggestion;
        const societyId = idSociete || selectedSocietyId || fallbackSocietyId;

        const requestParameters: ReminderPublisherApiPrepareReminderPublisherReminderPublisherCollectionRequest =
            {
                xIdSociete: societyId,
                reminderPublisherJsonldReminderPublisherWriteTimestampableBlameambleGroupSocieteAwareGroup:
                    {
                        fournisseurId: fournisseur.id.toString(),
                        factureIds: factures.map((facture) => facture.id.toString()),
                        customMessage: customMessage.trim(),
                        idSociete: societyId,
                    },
            };

        return request(
            reminderPublisherApi.prepareReminderPublisherReminderPublisherCollection(
                requestParameters,
            ),
            { withToaster: false },
        );
    },
};
